import React from 'react'
import { setOpenRegisterPopup } from 'redux/actions'
import { connect } from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import { withStyles, Typography, Box } from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import Button from 'components/Button';

const style = theme => ({
	padding: {
		marginTop: theme.spacing(2)
	}
})

function RegisterPopup({
	registerPopup,
	setOpenRegisterPopup,
	classes
}) {

	const onClose = () => {
		setOpenRegisterPopup(false)
	}

	if (!registerPopup) return ''
	return (
		<Dialog
			title={Tr('contact_with_us')}
			open={registerPopup}
			maxWidth={'xs'}
			onClose={onClose}
		>
			<GridBlock column>

				<Typography component='span' variant='body1'>
					{Tr("company_phone_number")}
				</Typography>

				<Box>
					<Typography component='span' variant='body1'>
						{`${Tr("email")}: `}
					</Typography>
					<Typography component='a' href={`mailto:${Tr('company_email')}`} variant='body1'>
						{Tr("company_email")}
					</Typography>
				</Box>

				<GridBlock justify='flex-end' className={classes.padding}>
					<Button onClick={onClose}> {Tr('close')} </Button>
				</GridBlock>

			</GridBlock>
		</Dialog>
	)
}

export default connect((state) => ({
	registerPopup: state.store.registerPopup,
}), {
		setOpenRegisterPopup
	})(withStyles(style)(RegisterPopup));